import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function Compliance() {
  const [visible, setVisible] = useState(false);
  const pdfPath = '/assets/Annual-General-Meeting-notice.pdf';

  return (
    <div style={styles.container}>
      <Header />

      <main style={styles.main}>
        <h1 style={styles.title}>Compliance</h1>

        <div style={styles.buttonContainer}>
          <button onClick={() => setVisible(true)} style={styles.buttonPrimary}>
            Open PDF
          </button>
          <button onClick={() => setVisible(false)} style={styles.buttonSecondary}>
            Close PDF
          </button>
        </div>

        {visible && (
          <div style={styles.pdfContainer}>
            <iframe
              title="Compliance PDF"
              src={pdfPath}
              style={styles.iframe}
            />
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: '#fafafa',
  },
  main: {
    flex: 1,
    padding: '1rem',
    width: '100%',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  title: {
    fontSize: 'clamp(1.5rem, 4vw, 2.5rem)', // responsive font size
    textAlign: 'center',
    color: '#006400',
    marginBottom: '1rem',
  },
  buttonContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '10px',
    marginBottom: '1rem',
  },
  buttonPrimary: {
    backgroundColor: '#007bff',
    color: '#fff',
    padding: '10px 18px',
    fontSize: '1rem',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    flex: '1 1 120px',
    maxWidth: '180px',
  },
  buttonSecondary: {
    backgroundColor: '#ccc',
    color: '#000',
    padding: '10px 18px',
    fontSize: '1rem',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    flex: '1 1 120px',
    maxWidth: '180px',
  },
  pdfContainer: {
    border: '1px solid #ddd',
    borderRadius: '8px',
    overflow: 'hidden',
    height: '75vh',
    marginTop: '1rem',
  },
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none',
  },
};
